<template>
    <div>
        <text-form-group
                v-model="data.headline"
                name="headline"
                label="Headline"
                :error="(errors.headline || [])[0]"
        />

        <div v-for="(image, index) in data.images" style="border: 1px solid black; border-radius: 15px; padding: 15px; margin-bottom: 15px">
            <gallery-form-group
                    v-model="image.id"
                    name="id"
                    label="Image"
            />

            <button type="button" class="btn btn-link btn-block" @click="removeImage(index)">
                <i class="fa fa-minus"/> Remove Image
            </button>
        </div>

        <button type="button" class="btn btn-black btn-block" style="margin-bottom: 15px;" @click="addImage">
            <i class="fa fa-plus"/> Add Image
        </button>
    </div>
</template>

<script>
    import GalleryFormGroup from '@/components/FormGroups/Horizontal/Gallery'
    import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

    export default {
        components: { GalleryFormGroup, TextFormGroup},

        props: {
            value: {
                required: true
            },

            errors: {
                required: true
            }
        },

        computed: {
            data: {
                get() {
                    return this.value
                },

                set(value) {
                    this.$emit('input', value)
                }
            }
        },

        methods: {
            addImage() {
                let images = this.data.images || []

                images.push({driver_parameters: {}})

                this.$emit('input', {...this.value, images})
            },

            removeImage(index) {
                let images = this.data.images || []

                images.splice(index, 1)

                this.$emit('input', {...this.value, images})
            }
        }
    }
</script>
